import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class ContactService extends RLBaseService {

    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    // TODO: Party filtering as a search group and use AdvancedSearch
    search(query: Models.ISearchRequest) {
        return this.toRLService<Models.IContactSearchResults>("/api/contact/search/").post(query).$promise;
    }

    searchTypeAhead(query: Models.ISearchRequest) {
        return this.toRLService<Models.ITypeAheadSearchResults>("/api/contact/searchtypeahead/").post(query).$promise;
    }

    executeWorkflow(actionId: number, contactIds: number[]) {
        return this.toRLService<Models.IExecuteContactWorkflowResults>("/api/contact/executeworkflow").post({ actionID: actionId, contactIDs: contactIds }).$promise;
    }

    getApplicationList() {
        return this.toRLService<Models.IApplicationInfo>("/api/contact/getapplicationlist").query().$promise;
    }

    getUserRoles() {
        return this.toRLService<Models.IAccountRole>("/api/contact/getuserroles").query().$promise;
    }

    //getUserGroups() {
    //    return this.toRLService<Models.IAccountGroup>("/api/contact/getusergroups").query().$promise;
    //}

    getRoleList() {
        return this.toRLService<Models.IAspNetUserRole>("/api/identity/getrolelist").query().$promise;
    }

    getPartyTemplates(charTypeID: number, templateID: number, partyID: number) {
        var data = {
            charTypeID: charTypeID,
            templateID: templateID,
            partyID: partyID
        };
        return this.toRLService<string>("/api/contact/getcharacteristictemplatepartytemplatelist").query(data).$promise;
    }

    createContact(templateID: string, charDatas: Models.ICharDatas, appUrlIDs: number[], roleIDs: number[], groupIDs: number[], identityRoleIDs: string[], password: string) {
        var data = {
            templateID: templateID,
            parentEntityID: null,
            charDatas: charDatas,
            roleIDs: roleIDs,
            groupIDs: groupIDs,
            identityRoleIDs: identityRoleIDs,
            appUrlIDs: appUrlIDs,
            password: password
        };
        return this.toRLService<Models.ICreateEntityResponse>("/api/contact/createcontact").post(data).$promise;
    }

    getHierarchy(assetId: number) {
        return this.toRLService<Models.IEntityNode>("/api/contact/getcontacthierarchy/:id", { id: "@id" }).get({ id: assetId }).$promise;
    }

    deleteAssociations(contactID: number, relRecIDs: number[]) {
        var data = {
            parentRecID: contactID,
            relRecIDs: relRecIDs
        };
        return this.toRLService<boolean>("/api/contact/deleteassociations").post(data).$promise;
    }

    createAssociations(contactID: number, childRecIDs: number[], directionID?: number) {
        var data = {
            parentRecID: contactID,
            ChildRecIDs: childRecIDs,
            Direction: directionID
        };
        return this.toRLService<boolean>("/api/contact/createassociations").post(data).$promise;
    }

    getUserSecurityInfo(contactID: string) {
        var data = {
            contactID: contactID
        };
        return this.toRLService<Models.IUserSecurity>("/api/contact/getusersecurityinfo").get(data).$promise;
    }

    setUserSecurityInfo(contactID: string, appUrlIDs: number[], roleIDs: number[], groupIDs: number[], identityRoleIDs: string[]) {
        var data = {
            contactID: contactID,
            roleIDs: roleIDs,
            groupIDs: groupIDs,
            appUrlIDs: appUrlIDs,
            identityRoleIDs: identityRoleIDs
        };
        return this.toRLService<void>("/api/contact/setusersecurityinfo").post(data).$promise;
    }

    getAssociatedContactTemplates() {
        return this.toRLService<Models.ICharacteristicTemplate>("/api/contact/getassociatedcontacttemplates").query().$promise;
    }

    createAssociatedContact(templateID: number, charDatas: Models.ICharDatas) {
        var data = {
            templateID: templateID,
            charDatas: charDatas
        };
        return this.toRLService<Models.ICreateEntityResponse>("/api/contact/CreateAssociatedContact").post(data).$promise;
    }

    getSuggestions(query: string) {
        return this.toRLService<Models.IEntity>("/api/contact/ContactSuggest").getArray({ keywords: query }).$promise;
    }

    associateContactToEntity(charTypeID: number, recordID: number, partyID: number, contactID: number, sequenceNumber: number) {
        var query = {
            charTypeID: charTypeID,
            recordID: recordID,
            partyID: partyID,
            contactID: contactID,
            sequenceNumber: sequenceNumber
        }

        return this.toRLService<Models.IEntity>("/api/contact/AssociateContactToEntity").post(query).$promise;
    }

    removeContactFromEntity(charTypeID: number, recordID: number, partyID: number, contactID: number) {
        var data = {
            charTypeID: charTypeID,
            recordID: recordID,
            partyID: partyID,
            contactID: contactID
        };

        return this.toRLService<void>("/api/contact/RemoveContactFromEntity").post(data).$promise;
    }

    updateContactPartyCharacteristics(charTypeID: number, recID: number, contactID: number, contactCharDatas: Models.ICharDatas, updateProfile: boolean) {
        var data: Models.IUpdateProjectContactCharacteristicsRequest = {
            charTypeID: charTypeID,
            contactCharDatas: contactCharDatas,
            contactID: contactID,
            recordID: recID,
            updateProfile: updateProfile
        };

        return this.toRLService<void>("/api/contact/UpdateContactPartyCharacteristics").post(data).$promise;
    }

    overwriteContacts(entityID: string, contactID: number, partyID: number) {
        var data = {
            entityID: entityID,
            contactID: contactID,
            partyID: partyID
        };

        return this.toRLService<Models.IJobResponse>("/api/contact/OverwriteContacts").post(data).$promise;
    }

    resyncContact(charTypeID: number, recordID: number, contactID: number) {
        var data = {
            charTypeID: charTypeID,
            recordID: recordID,
            contactID: contactID
        };

        return this.toRLService<void>("/api/contact/ResyncContact").post(data).$promise;
    }

    getContactsForEntity(entityID: string) {
        var data = {
            entityID: entityID
        };

        return this.toRLService<Models.IContactParty>("/api/contact/GetContacts", {}).query(data).$promise;
    }

    getContactsForEntityByParty(entityID: string, partyID: number) {
        var data = {
            entityID: entityID,
            partyID: partyID
        };

        return this.toRLService<Models.IContactParty>("/api/contact/GetContactsByParty", {}).get(data).$promise;
    }

	getRecordContactTitles(entityID: string) {
		var data = {
			entityID: entityID
		};
		return this.toRLService<{ data: { [contactRecID: number]: string } }>("/api/contact/getrecordcontacttitles").get(data).$promise;
	}
}